import { render, staticRenderFns } from "./platformDetail.vue?vue&type=template&id=4be8a585"
import script from "./platformDetail.vue?vue&type=script&lang=js"
export * from "./platformDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports